// extracted by mini-css-extract-plugin
module.exports = {"notification":"ReferralNotification_notification__3bu42","icon_container":"ReferralNotification_icon_container__3rctr","body":"ReferralNotification_body__3prbg"};